import React from "react";
import "./App.css";

export default function App() {
  React.useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }, []);

  return (
    <div className="page">
      <div className="page-bg" />

      <main className="main">
        <p className="badge">Launching Soon</p>

        <h1 className="title">Suggesly Is Coming Soon</h1>

        <p className="subtitle">
          We are putting the final touches on a smarter sales experience. Stay
          tuned for our official launch.
        </p>

        <a
          href="https://forms.gle/FDArmnpDCT8R8FoAA"
          target="_blank"
          rel="noreferrer"
          className="waitlist-btn"
        >
          Join the Early Access Waitlist
        </a>

        <p className="contact">
          Reach us at{" "}
          <a href="mailto:admin@sugglesly.com" className="contact-link">
            admin@sugglesly.com
          </a>
        </p>
      </main>

      <footer className="footer">
        <p className="footer-inner">
          <img
            src="/assets/suggesly_icon.png"
            alt="Suggesly icon"
            className="footer-icon"
          />
          <span>
            Copyright © {new Date().getFullYear()} Suggesly. All rights reserved.{" "}
          </span>
          <a
            href="https://www.linkedin.com/company/suggesly-crm/"
            target="_blank"
            rel="noreferrer"
            className="footer-link"
          >
            LinkedIn
          </a>
        </p>
      </footer>
    </div>
  );
}
